export const kCaseCardTileType = "CaseCard"
export const kV2CaseCardType = "caseCard"
export const kCaseCardTileClass = "codap-case-card"
export const kCaseCardMinWidth = 150
